import type { TranslationModule } from '../types';

export const extrasCfTranslations: TranslationModule = {
  ro: {
    seoTitle: "Extras Carte Funciară Online — LegeaAplicata.ro | De la 59 lei",
    seoDesc: "Obțineți extrasul de carte funciară online, fără deplasare. Livrare rapidă pe email: Standard (1 zi lucrătoare) sau Prioritar (~15 minute). Extras Informativ și Autentic pentru notar/bancă. De la 59 lei + TVA.",
    seoKeywords: "extras carte funciara online, CF online, extras CF rapid, extras de carte funciara, ANCPI online, OCPI online, extras informativ, extras autentic, carte funciara imobil",
    breadcrumbHome: "Acasă",
    breadcrumbServices: "Servicii",
    breadcrumbCurrent: "Extras Carte Funciară",
    heroBadge: "Serviciu Oficial ANCPI / OCPI",
    heroTitle: "Extras Carte Funciară Online",
    heroDesc: "Obțineți rapid și fără deplasări extrasul de carte funciară necesar pentru tranzacții imobiliare, credite bancare sau proceduri notariale. Livrare pe email în 1 zi lucrătoare sau ~15 minute cu opțiunea prioritară.",
    heroBullet1: "Document oficial ANCPI",
    heroBullet2: "Fără deplasare la OCPI",
    heroBullet3: "Livrare pe email",
    heroBullet4: "Extras Informativ sau Autentic",
    priceFrom: "De la",
    priceTva: "+ TVA / extras",
    btnOrderNow: "Solicită acum",
    howItWorksTitle: "Cum funcționează procesul la distanță?",
    step1Title: "1. Completezi formularul",
    step1Desc: "Date imobil, contact și tipul de extras.",
    step2Title: "2. Ești contactat",
    step2Desc: "Confirmăm disponibilitatea și detaliile de plată.",
    step3Title: "3. Plătești",
    step3Desc: "Transfer bancar sau link de plată online.",
    step4Title: "4. Primești documentul",
    step4Desc: "Extras CF pe email în termenul ales.",
    infoBoxTitle: "Ce este Extrasul de Carte Funciară?",
    infoBoxText1: "Extrasul de carte funciară este documentul oficial care atestă dreptul de proprietate și situația juridică a unui imobil (teren sau construcție). Acesta este eliberat de Agenția Națională de Cadastru și Publicitate Imobiliară (ANCPI) prin oficiile teritoriale (OCPI).",
    infoBoxText2: "Este solicitat obligatoriu la tranzacții imobiliare, credite ipotecare, succesiuni, partaje și alte proceduri notariale sau judiciare.",
    benefitsTitle: "De ce să folosești serviciul nostru?",
    benefit1Title: "Livrare rapidă",
    benefit1Desc: "Standard în 1 zi lucrătoare sau Prioritar în ~15 minute.",
    benefit2Title: "Date securizate",
    benefit2Desc: "Datele dvs. sunt protejate conform GDPR și folosite exclusiv pentru procesarea solicitării.",
    benefit3Title: "Documente oficiale",
    benefit3Desc: "Extrasele sunt obținute oficial de la ANCPI/OCPI și sunt valabile legal.",
    benefit4Title: "Fără deplasări",
    benefit4Desc: "Completați formularul online, noi ne ocupăm de tot restul.",
    faqTitle: "Întrebări frecvente",
    faqQ1: "Cât costă un extras de carte funciară?",
    faqA1: "Costul este 59 lei + TVA pentru livrare standard. Opțional, livrarea prioritară costă +39 lei + TVA.",
    faqQ2: "De unde știu numărul cărții funciare?",
    faqA2: "Îl găsiți pe actul de proprietate (contract de vânzare-cumpărare, contract de donație etc.) sau pe chitanța de la OCPI. Puteți folosi și numărul cadastral dacă nu cunoașteți CF-ul.",
    faqQ3: "Cât este valabil extrasul CF?",
    faqA3: "Un extras CF informativ este valabil 30 de zile. Cel autentic (pentru notar sau bancă) are valabilitate specifică instituției care îl solicită.",
    faqQ4: "Când și cum plătesc?",
    faqA4: "Vă contactăm după trimiterea solicitării cu detalii de plată (OP bancar sau link de plată online). Documentul este livrat după confirmarea plății.",
    formTitle: "Solicită Extrasul de Carte Funciară",
    formSubtitle: "Completați formularul de mai jos. Toate câmpurile marcate cu * sunt obligatorii.",
    formSectionImobil: "Informații despre Imobil",
    labelServiciu: "Serviciu solicitat",
    placeholderServiciu: "Selectați tipul de document dorit",
    optServiciu1: "Extras CF Informativ",
    optServiciu2: "Extras CF Autentic (pentru notar/bancă)",
    optServiciu3: "Extras CF Informativ + Plan Cadastral",
    optServiciu4: "Extras CF Autentic + Plan Cadastral",
    labelJudet: "Județ imobil",
    placeholderJudet: "Alege un județ",
    labelLocalitate: "Localitate / Sector",
    placeholderLocalitate: "Ex: Timișoara / Sector 2",
    labelCF: "Numărul Cărții Funciare",
    placeholderCF: "Ex: 51871 / 220700",
    descCF: "Introduceți cel puțin CF sau Cadastral.",
    labelCadastral: "Numărul Cadastral",
    placeholderCadastral: "220700, 50131-C1-U2, etc.",
    descCadastral: "Lăsați gol dacă nu cunoașteți.",
    labelTopografic: "Număr Topografic",
    labelTopograficOptional: "(opțional)",
    placeholderTopografic: "1501/2, 305/1, etc.",
    labelNecesarLa: "Necesar la",
    placeholderNecesarLa: "Credit, reînnoire CI, etc.",
    formSectionContact: "Date de Contact și Facturare",
    labelNume: "Nume și prenume",
    placeholderNume: "Numele și prenumele dvs.",
    labelTelefon: "Telefon",
    placeholderTelefon: "Ex: 0728 778 458",
    labelEmail: "Adresă de email",
    placeholderEmail: "email@exemplu.ro",
    descEmail: "Documentul va fi livrat pe această adresă.",
    labelAdresaFacturare: "Adresă de facturare",
    placeholderAdresaFacturare: "Localitate, Județ, Stradă, Nr, Bloc, Apartament",
    labelFacturaFirma: "Doresc factură pe firmă",
    labelCuiFirma: "CUI Firmă",
    placeholderCuiFirma: "Introduceți CUI-ul firmei",
    labelWhatsapp: "Doresc documentul și pe WhatsApp",
    descWhatsapp: "Livrarea principală rămâne pe email.",
    formSectionLivrare: "Opțiuni de Livrare",
    optLivrareStandardTitle: "Standard",
    optLivrareStandardSub: "1 zi lucrătoare",
    optLivrareStandardDetail1: "Livrare pe email în 1 zi lucrătoare",
    optLivrareStandardDetail2: "Calitate garantată",
    optLivrareStandardDetail3: "Suport inclus",
    optLivrarePrioritarTitle: "Prioritar",
    optLivrarePrioritarSub: "~15 minute",
    optLivrarePrioritarDetail1: "Procesare urgentă (~15 min)",
    optLivrarePrioritarDetail2: "Disponibil în program orar",
    optLivrarePrioritarDetail3: "Confirmare telefonică imediată",
    labelTotalPay: "Total de achitat:",
    formSectionAcord: "Rezumat și Acord",
    summaryTitle: "Rezumat Comandă",
    summaryServiceLabel: "Serviciu",
    summaryServiceName: "Extras Carte Funciară",
    summaryPriceLabel: "Preț serviciu",
    summaryPriorityLabel: "Prioritate livrare",
    summaryTimeLabel: "Timp livrare",
    summaryTimePrioritar: "~15 minute (Prioritar)",
    summaryTimeStandard: "1 zi lucrătoare (Standard)",
    summaryTotalLabel: "Total (fără TVA)",
    paymentInfoTitle: "Mod plată:",
    paymentInfoText: "Vă vom contacta după trimiterea solicitării cu detaliile de plată (transfer bancar sau link de plată online). Documentul este livrat după confirmarea plății.",
    agreementTextPart1: "Sunt de acord cu ",
    agreementTermsLink: "Termenii și Condițiile",
    agreementTextPart2: " și ",
    agreementPrivacyLink: "Politica de Confidențialitate",
    agreementTextPart3: ". Înțeleg că plata se efectuează după confirmarea disponibilității documentului.",
    btnSubmit: "Trimite Solicitarea",
    btnProcessing: "Se procesează solicitarea...",
    formFooterText: "🔒 Datele dvs. sunt securizate conform GDPR. Nu stocăm datele fără consimțământul dvs. Veți fi contactat în cel mai scurt timp posibil.",
    valRequiredServiciu: "Serviciul solicitat este obligatoriu.",
    valRequiredJudet: "Județul imobilului este obligatoriu.",
    valRequiredLocalitate: "Localitatea/Sectorul trebuie să aibă minim 3 caractere.",
    valRequiredCF: "Cel puțin Nr. CF sau Nr. Cadastral este obligatoriu.",
    valRequiredNume: "Numele trebuie să aibă minim 3 caractere.",
    valRequiredEmail: "Adresa de email nu este validă.",
    valRequiredTelefon: "Numărul de telefon nu este valid. Ex: 0728778458",
    valRequiredAdresa: "Adresa trebuie să aibă minim 5 caractere.",
    valRequiredCui: "CUI-ul firmei este obligatoriu.",
    valRequiredAcord: "Acceptarea termenilor este obligatorie.",
    msgSubmitSuccess: "Solicitarea a fost trimisă cu succes!",
    msgSubmitError: "Eroare la trimiterea solicitării.",
    errorBannerTitle: "Eroare la trimitere"
  },
  en: {
    seoTitle: "Land Registry Extract Online — LegeaAplicata.ro | From 59 lei",
    seoDesc: "Get your land registry extract online without travel. Rapid email delivery: Standard (1 business day) or Priority (~15 minutes). Informative and Authentic Extract for notary/bank. From 59 lei + VAT.",
    seoKeywords: "online land registry extract, online CF, rapid land registry, ANCPI online, OCPI online, informative extract, authentic extract, land registry document",
    breadcrumbHome: "Home",
    breadcrumbServices: "Services",
    breadcrumbCurrent: "Land Registry Extract",
    heroBadge: "Official ANCPI / OCPI Service",
    heroTitle: "Land Registry Extract Online",
    heroDesc: "Obtain your land registry extract quickly and without travel, necessary for real estate transactions, bank loans, or notary procedures. Delivery by email in 1 business day or ~15 minutes with the priority option.",
    heroBullet1: "Official ANCPI Document",
    heroBullet2: "No travel to OCPI",
    heroBullet3: "Email delivery",
    heroBullet4: "Informative or Authentic Extract",
    priceFrom: "From",
    priceTva: "+ VAT / extract",
    btnOrderNow: "Apply now",
    howItWorksTitle: "How does the remote process work?",
    step1Title: "1. Fill out the form",
    step1Desc: "Property info, contact details, and type of extract.",
    step2Title: "2. We contact you",
    step2Desc: "We confirm availability and payment details.",
    step3Title: "3. Pay",
    step3Desc: "Bank transfer or online payment link.",
    step4Title: "4. Receive the document",
    step4Desc: "Land registry extract on email in the chosen timeframe.",
    infoBoxTitle: "What is a Land Registry Extract?",
    infoBoxText1: "The land registry extract (Extras de Carte Funciară) is the official document certifying ownership rights and the legal situation of a property (land or building). It is issued by the National Agency for Cadastre and Land Registration (ANCPI) through the territorial offices (OCPI).",
    infoBoxText2: "It is mandatory for real estate transactions, mortgage loans, successions, partitions, and other notary or judicial procedures.",
    benefitsTitle: "Why use our service?",
    benefit1Title: "Fast delivery",
    benefit1Desc: "Standard in 1 business day or Priority in ~15 minutes.",
    benefit2Title: "Secure data",
    benefit2Desc: "Your data is protected in compliance with GDPR and used exclusively to process the request.",
    benefit3Title: "Official documents",
    benefit3Desc: "Extracts are officially obtained from ANCPI/OCPI and are legally valid.",
    benefit4Title: "No travel required",
    benefit4Desc: "Fill in the online form, we handle everything else.",
    faqTitle: "Frequently Asked Questions",
    faqQ1: "How much does a land registry extract cost?",
    faqA1: "The cost is 59 lei + VAT for standard delivery. Optionally, priority delivery costs +39 lei + VAT.",
    faqQ2: "How do I know the land registry number?",
    faqA2: "You can find it on the ownership deed (sale-purchase contract, donation contract, etc.) or on the receipt from OCPI. You can also use the cadastral number if you do not know the CF number.",
    faqQ3: "How long is the land registry extract valid?",
    faqA3: "An informative CF extract is valid for 30 days. The authentic one (for notary or bank) has a specific validity required by the requesting institution.",
    faqQ4: "When and how do I pay?",
    faqA4: "We will contact you after submitting the request with payment details (bank transfer or online payment link). The document is delivered after payment confirmation.",
    formTitle: "Request Land Registry Extract",
    formSubtitle: "Fill out the form below. All fields marked with * are mandatory.",
    formSectionImobil: "Property Information",
    labelServiciu: "Requested Service",
    placeholderServiciu: "Select the desired type of document",
    optServiciu1: "Informative CF Extract",
    optServiciu2: "Authentic CF Extract (for notary/bank)",
    optServiciu3: "Informative CF Extract + Cadastral Plan",
    optServiciu4: "Authentic CF Extract + Cadastral Plan",
    labelJudet: "Property County",
    placeholderJudet: "Choose a county",
    labelLocalitate: "Locality / Sector",
    placeholderLocalitate: "E.g., Timisoara / Sector 2",
    labelCF: "Land Registry Number (CF)",
    placeholderCF: "E.g., 51871 / 220700",
    descCF: "Enter at least CF or Cadastral number.",
    labelCadastral: "Cadastral Number",
    placeholderCadastral: "220700, 50131-C1-U2, etc.",
    descCadastral: "Leave empty if not known.",
    labelTopografic: "Topographic Number",
    labelTopograficOptional: "(optional)",
    placeholderTopografic: "1501/2, 305/1, etc.",
    labelNecesarLa: "Needed for",
    placeholderNecesarLa: "Credit, ID renewal, etc.",
    formSectionContact: "Contact & Billing Information",
    labelNume: "Full Name",
    placeholderNume: "Your full name",
    labelPhone: "Phone",
    placeholderPhone: "E.g., 0728 778 458",
    labelEmail: "Email Address",
    placeholderEmail: "email@example.com",
    descEmail: "The document will be delivered to this address.",
    labelAdresaFacturare: "Billing Address",
    placeholderAdresaFacturare: "Locality, County, Street, No, Block, Apartment",
    labelFacturaFirma: "I want invoice on company",
    labelCuiFirma: "Company Fiscal Code (CUI)",
    placeholderCuiFirma: "Enter company CUI",
    labelWhatsapp: "I want the document on WhatsApp as well",
    descWhatsapp: "Main delivery remains on email.",
    formSectionLivrare: "Delivery Options",
    optLivrareStandardTitle: "Standard",
    optLivrareStandardSub: "1 business day",
    optLivrareStandardDetail1: "Email delivery in 1 business day",
    optLivrareStandardDetail2: "Guaranteed quality",
    optLivrareStandardDetail3: "Support included",
    optLivrarePrioritarTitle: "Priority",
    optLivrarePrioritarSub: "~15 minutes",
    optLivrarePrioritarDetail1: "Urgent processing (~15 min)",
    optLivrarePrioritarDetail2: "Available during working hours",
    optLivrarePrioritarDetail3: "Immediate phone confirmation",
    labelTotalPay: "Total to pay:",
    formSectionAcord: "Summary & Agreement",
    summaryTitle: "Order Summary",
    summaryServiceLabel: "Service",
    summaryServiceName: "Land Registry Extract",
    summaryPriceLabel: "Service price",
    summaryPriorityLabel: "Delivery priority",
    summaryTimeLabel: "Delivery time",
    summaryTimePrioritar: "~15 minutes (Priority)",
    summaryTimeStandard: "1 business day (Standard)",
    summaryTotalLabel: "Total (without VAT)",
    paymentInfoTitle: "Payment method:",
    paymentInfoText: "We will contact you after sending the request with the payment details (bank transfer or online payment link). The document is delivered after payment confirmation.",
    agreementTextPart1: "I agree to the ",
    agreementTermsLink: "Terms and Conditions",
    agreementTextPart2: " and the ",
    agreementPrivacyLink: "Privacy Policy",
    agreementTextPart3: ". I understand that payment is made after confirming the document availability.",
    btnSubmit: "Submit Request",
    btnProcessing: "Processing request...",
    formFooterText: "🔒 Your data is secure under GDPR. We do not store data without your consent. You will be contacted as soon as possible.",
    valRequiredServiciu: "Requested service is mandatory.",
    valRequiredJudet: "Property county is mandatory.",
    valRequiredLocalitate: "Locality/Sector must be at least 3 characters.",
    valRequiredCF: "At least CF or Cadastral number is mandatory.",
    valRequiredNume: "Name must be at least 3 characters.",
    valRequiredEmail: "Email address is not valid.",
    valRequiredTelefon: "Phone number is not valid. E.g., 0728778458",
    valRequiredAdresa: "Address must be at least 5 characters.",
    valRequiredCui: "Company CUI is mandatory.",
    valRequiredAcord: "Accepting the terms is mandatory.",
    msgSubmitSuccess: "Request submitted successfully!",
    msgSubmitError: "Error submitting the request.",
    errorBannerTitle: "Submission error"
  },
  fr: {
    seoTitle: "Extrait de Registre Foncier en Ligne — LegeaAplicata.ro | À partir de 59 lei",
    seoDesc: "Obtenez votre extrait de registre foncier en ligne, sans déplacement. Livraison rapide par email : Standard (1 jour ouvrable) ou Prioritaire (~15 minutes). Extrait Informatif et Authentique pour notaire/banque. À partir de 59 lei + TVA.",
    seoKeywords: "extrait de registre foncier en ligne, CF en ligne, extrait CF rapide, ANCPI en ligne, OCPI en ligne, extrait informatif, extrait authentique, document registre foncier",
    breadcrumbHome: "Accueil",
    breadcrumbServices: "Services",
    breadcrumbCurrent: "Extrait de Registre Foncier",
    heroBadge: "Service Officiel ANCPI / OCPI",
    heroTitle: "Extrait de Registre Foncier en Ligne",
    heroDesc: "Obtenez rapidement et sans déplacement l'extrait de registre foncier nécessaire pour vos transactions immobilières, prêts bancaires ou procédures notariales. Livraison par email en 1 jour ouvrable ou ~15 minutes avec l'option prioritaire.",
    heroBullet1: "Document officiel ANCPI",
    heroBullet2: "Sans déplacement à l'OCPI",
    heroBullet3: "Livraison par e-mail",
    heroBullet4: "Extrait Informatif ou Authentique",
    priceFrom: "À partir de",
    priceTva: "+ TVA / extrait",
    btnOrderNow: "Demander maintenant",
    howItWorksTitle: "Comment fonctionne le processus à distance ?",
    step1Title: "1. Remplir le formulaire",
    step1Desc: "Données de l'immeuble, contact et type d'extrait.",
    step2Title: "2. Vous êtes contacté",
    step2Desc: "Nous confirmons la disponibilité et les détails de paiement.",
    step3Title: "3. Payer",
    step3Desc: "Virement bancaire ou lien de paiement en ligne.",
    step4Title: "4. Recevoir le document",
    step4Desc: "Extrait CF par e-mail dans le délai choisi.",
    infoBoxTitle: "Qu'est-ce qu'un Extrait de Registre Foncier ?",
    infoBoxText1: "L'extrait de registre foncier (Extras de Carte Funciară) est le document officiel qui atteste du droit de propriété et de la situation juridique d'un immeuble (terrain ou construction). Il est délivré par l'Agence Nationale du Cadastre et de la Publicité Foncière (ANCPI) via ses bureaux territoriaux (OCPI).",
    infoBoxText2: "Il est obligatoirement requis lors de transactions immobilières, de prêts hypothécaires, de successions, de partages et d'autres procédures notariales ou judiciaires.",
    benefitsTitle: "Pourquoi utiliser notre service ?",
    benefit1Title: "Livraison rapide",
    benefit1Desc: "Standard en 1 jour ouvrable ou Prioritaire en ~15 minutes.",
    benefit2Title: "Données sécurisées",
    benefit2Desc: "Vos données sont protégées conformément au RGPD et utilisées exclusivement pour traiter la demande.",
    benefit3Title: "Documents officiels",
    benefit3Desc: "Les extraits sont officiellement obtenus auprès de l'ANCPI/OCPI et sont légalement valides.",
    benefit4Title: "Sans déplacements",
    benefit4Desc: "Remplissez le formulaire en ligne, nous nous occupons du reste.",
    faqTitle: "Questions fréquemment posées",
    faqQ1: "Combien coûte un extrait de registre foncier ?",
    faqA1: "Le coût est de 59 lei + TVA pour la livraison standard. En option, la livraison prioritaire coûte +39 lei + TVA.",
    faqQ2: "Comment connaître le numéro de registre foncier ?",
    faqA2: "Vous le trouverez sur l'acte de propriété (contrat de vente, acte de donation, etc.) ou sur le reçu de l'OCPI. Vous pouvez également utiliser le numéro cadastral si vous ne connaissez pas le numéro CF.",
    faqQ3: "Combien de temps l'extrait CF est-il valide ?",
    faqA3: "Un extrait CF informatif est valide pendant 30 jours. L'extrait authentique (pour notaire ou banque) a une validité spécifique requise par l'institution demandeuse.",
    faqQ4: "Quand et comment payer ?",
    faqA4: "Nous vous contacterons après l'envoi de la demande avec les détails de paiement (virement bancaire ou lien de paiement en ligne). Le document est livré après confirmation du paiement.",
    formTitle: "Demander l'Extrait de Registre Foncier",
    formSubtitle: "Remplissez le formulaire ci-dessous. Tous les champs marqués d'une * sont obligatoires.",
    formSectionImobil: "Informations sur l'Immeuble",
    labelServiciu: "Service demandé",
    placeholderServiciu: "Sélectionnez le type de document souhaité",
    optServiciu1: "Extrait CF Informatif",
    optServiciu2: "Extrait CF Authentique (pour notaire/banque)",
    optServiciu3: "Extrait CF Informatif + Plan Cadastral",
    optServiciu4: "Extrait CF Authentique + Plan Cadastral",
    labelJudet: "Département de l'immeuble",
    placeholderJudet: "Choisissez un département",
    labelLocalitate: "Localité / Secteur",
    placeholderLocalitate: "Ex: Timisoara / Secteur 2",
    labelCF: "Numéro de Registre Foncier (CF)",
    placeholderCF: "Ex: 51871 / 220700",
    descCF: "Saisissez au moins le CF ou le numéro cadastral.",
    labelCadastral: "Numéro Cadastral",
    placeholderCadastral: "220700, 50131-C1-U2, etc.",
    descCadastral: "Laissez vide si inconnu.",
    labelTopografic: "Numéro Topographique",
    labelTopograficOptional: "(optionnel)",
    placeholderTopografic: "1501/2, 305/1, etc.",
    labelNecesarLa: "Nécessaire pour",
    placeholderNecesarLa: "Prêt, renouvellement de carte d'identité, etc.",
    formSectionContact: "Coordonnées & Facturation",
    labelNume: "Nom et prénom",
    placeholderNume: "Votre nom et prénom",
    labelPhone: "Téléphone",
    placeholderPhone: "Ex: 0728 778 458",
    labelEmail: "Adresse e-mail",
    placeholderEmail: "email@exemple.fr",
    descEmail: "Le document sera livré à cette adresse.",
    labelAdresaFacturare: "Adresse de facturation",
    placeholderAdresaFacturare: "Localité, Département, Rue, N°, Bâtiment, Appartement",
    labelFacturaFirma: "Je souhaite une facture au nom de l'entreprise",
    labelCuiFirma: "Numéro Fiscal de l'Entreprise (CUI)",
    placeholderCuiFirma: "Entrez le CUI de l'entreprise",
    labelWhatsapp: "Je souhaite également recevoir le document sur WhatsApp",
    descWhatsapp: "La livraison principale reste par e-mail.",
    formSectionLivrare: "Options de Livraison",
    optLivrareStandardTitle: "Standard",
    optLivrareStandardSub: "1 jour ouvrable",
    optLivrareStandardDetail1: "Livraison par e-mail en 1 jour ouvrable",
    optLivrareStandardDetail2: "Qualité garantie",
    optLivrareStandardDetail3: "Support inclus",
    optLivrarePrioritarTitle: "Prioritaire",
    optLivrarePrioritarSub: "~15 minutes",
    optLivrarePrioritarDetail1: "Traitement urgent (~15 min)",
    optLivrarePrioritarDetail2: "Disponible pendant les heures ouvrables",
    optLivrarePrioritarDetail3: "Confirmation téléphonique immédiate",
    labelTotalPay: "Total à payer :",
    formSectionAcord: "Résumé & Accord",
    summaryTitle: "Résumé de la Commande",
    summaryServiceLabel: "Service",
    summaryServiceName: "Extrait de Registre Foncier",
    summaryPriceLabel: "Prix du service",
    summaryPriorityLabel: "Priorité de livraison",
    summaryTimeLabel: "Délai de livraison",
    summaryTimePrioritar: "~15 minutes (Prioritaire)",
    summaryTimeStandard: "1 jour ouvrable (Standard)",
    summaryTotalLabel: "Total (hors TVA)",
    paymentInfoTitle: "Mode de paiement :",
    paymentInfoText: "Nous vous contacterons après l'envoi de la demande avec les détails de paiement (virement bancaire ou lien de paiement en ligne). Le document est livré après confirmation du paiement.",
    agreementTextPart1: "Je suis d'accord avec les ",
    agreementTermsLink: "Conditions Générales",
    agreementTextPart2: " et la ",
    agreementPrivacyLink: "Politique de Confidentialité",
    agreementTextPart3: ". Je comprends que le paiement est effectué après confirmation de la disponibilité du document.",
    btnSubmit: "Envoyer la Demande",
    btnProcessing: "Traitement de la demande en cours...",
    formFooterText: "🔒 Vos données sont sécurisées conformément au RGPD. Nous ne stockons pas de données sans votre consentement. Vous serez contacté dans les plus brefs délais.",
    valRequiredServiciu: "Le service demandé est obligatoire.",
    valRequiredJudet: "Le département de l'immeuble est obligatoire.",
    valRequiredLocalitate: "La localité/le secteur doit comporter au moins 3 caractères.",
    valRequiredCF: "Au moins le numéro CF ou le numéro cadastral est obligatoire.",
    valRequiredNume: "Le nom doit comporter au moins 3 caractères.",
    valRequiredEmail: "L'adresse e-mail n'est pas valide.",
    valRequiredTelefon: "Le numéro de téléphone n'est pas valide. Ex: 0728778458",
    valRequiredAdresa: "L'adresse doit comporter au moins 5 caractères.",
    valRequiredCui: "Le CUI de l'entreprise est obligatoire.",
    valRequiredAcord: "L'acceptation des conditions est obligatoire.",
    msgSubmitSuccess: "Demande envoyée avec succès !",
    msgSubmitError: "Demande de soumission échouée.",
    errorBannerTitle: "Erreur de soumission"
  }
};

export default extrasCfTranslations;
